import clickWrap from "@js/helpers/click_wrap.js";

const ModalHeader = (props) => {
  let headerCancelX = props.onCancel && (
    <button className="close" type="button" onClick={clickWrap(props.onCancel)}>
      ×
    </button>
  );

  return props.children ? (
    <div className="modal-header">{props.children}</div>
  ) : headerCancelX || props.title ? (
    <div className="modal-header">
      {headerCancelX}
      {props.title && <h3>{props.title}</h3>}
    </div>
  ) : null;
};

export default ModalHeader;
